import React, { Component } from 'react'
import { Button, Divider, Popconfirm, Tabs, Typography } from 'antd'
import { ShelterKioskReasonContextData } from '../../../../context/ShelterKioskReasonContext'
import { QuestionConsumer, QuestionProvider } from '../../../../context/QuestionContext'
import ReasonQuestion from '../ReasonQuestion'
import ShelterReasonTranslation from '../ShelterReasonTranslation'
import EditShelterReason from '../EditShelterReason'
import ReasonSmartResponse from '../ReasonSmartResponse'

type ShelterReasonProps = {
  shelterUuid: string,
  branchUuid: string,
  context: ShelterKioskReasonContextData,
  addButtonContent: any
  goBack: any
}

export default class ShelterReason extends Component<ShelterReasonProps> {

  handleRemove = async (reasonUuid: string) => {
    const { context } = this.props

    await context.requestShelterKioskReasonDelete({
      shelter_kiosk_reason_uuid: reasonUuid
    })
  }

  render() {
    const { shelterUuid, branchUuid, context, goBack, addButtonContent } = this.props

    return (
      <QuestionProvider>
        <QuestionConsumer>
          {(questonContext) => (
            <Tabs tabBarExtraContent={{ left: goBack, right: addButtonContent }}>
              {
                context.shelterKioskReasons?.filter(shelterReason => shelterReason.reason).map(shelterReason => (
                  <Tabs.TabPane key={shelterReason.uuid} tab={shelterReason.name}>
                    <EditShelterReason
                      branchUuid={branchUuid}
                      reasonUuid={shelterReason.reason?.uuid || ''}
                      context={context}
                    />

                    <Divider />

                    <ShelterReasonTranslation
                      branchUuid={branchUuid}
                      reasonUuid={shelterReason.reason?.uuid || ''}
                      context={context}
                    />

                    <Divider />

                    <ReasonSmartResponse
                      branchUuid={branchUuid}
                      reasonUuid={shelterReason.reason?.uuid || ''}
                      context={context}
                    />

                    

                    <Divider />

                    <Typography.Title level={3}>Kiosk Questions</Typography.Title>
                    <ReasonQuestion
                      shelterUuid={shelterUuid}
                      reasonUuid={shelterReason.reason?.uuid || ''}
                      context={questonContext}
                      updateKioskQuestion={context.requestShelterKioskReasonUpdateQuestion}
                      loading={context.fetching || false}
                    />
    
                    <Divider />
    
                    <Popconfirm
                      title="Remove reason from shelter?"
                      onConfirm={() => this.handleRemove(shelterReason.uuid)}
                    >
                      <Button
                        type="dashed"
                        size="large"
                        loading={context.fetching || false}
                        block
                      >
                        Remove Reason
                      </Button>
                    </Popconfirm>
                  </Tabs.TabPane>
                ))
              }
            </Tabs>
          )}
        </QuestionConsumer>
      </QuestionProvider>
    )
  }
}
